module.exports = __webpack_public_path__ + "static/bg-chalk-23443651b8c00e6952727b96b3aa3284.jpg";